import React, { Fragment } from 'react';
import { string, arrayOf, func } from 'prop-types';
import { Box } from 'grid-styled';
import MenuItem from 'material-ui/MenuItem';
import Divider from 'material-ui/Divider';

import { convertToYearlyPrecision, lowestInterval } from '../utils/time';
import MetricSelector from './MetricSelector';
import PrecisionSelector from './PrecisionSelector';
import TimespanSelector from './TimespanSelector';
import CompareSelector from './CompareSelector';
import MonthYearRange from './MonthYearRange';
import { Compare, Timespan, Precision } from '../constants';
import {
  Precision as IPrecision,
  Metric as IMetric,
  Compare as ICompare,
  Timespan as ITimespan,
} from '../models';

const Container = Box.extend`
  & > *:not(:last-child) {
    margin-bottom: 16px !important;
  }
`;

const DataSettings = ({
  precision,
  compare,
  metric,
  timespan,
  compareInterval,
  timespanInterval,

  timeBounds,
  availableCompare,
  censusView,

  setMetric,
  setTimespan,
  setPrecision,
  setCompare,
  setCustomTimespanInterval,
  setCustomCompareInterval,
}) => {
  if (!timeBounds) return null;

  return (
    <Container>
      <MetricSelector
        labelColor="rgba(0, 0, 0, 0.87)"
        value={metric}
        onChange={setMetric}
        withTitle={false}
        inDataSettings={true}
      />
      <Divider />
      <TimespanSelector
        labelColor="rgba(0, 0, 0, 0.87)"
        value={timespan}
        onChange={setTimespan}
        inDataSettings={true}
      >
        <MenuItem
          value={Timespan.CUSTOM}
          primaryText="Custom"
          onClick={() => setTimespan(Timespan.CUSTOM)}
        />
      </TimespanSelector>
      <PrecisionSelector
        value={precision}
        onChange={setPrecision}
        disabled={false}
        inDataSettings={true}
      />
      <MonthYearRange
        selected={timespanInterval}
        yearsOnly={precision === Precision.YEARLY}
        bounds={
          precision === Precision.MONTHLY
            ? timeBounds
            : convertToYearlyPrecision(timeBounds, timeBounds)
        }
        onChange={setCustomTimespanInterval}
      />
      <Divider />
      {!censusView && (
        <Fragment>
          <CompareSelector
            value={compare}
            timespanInterval={compareInterval}
            availableCompare={availableCompare}
            onChange={setCompare}
            labelColor="rgba(0, 0, 0, 0.87)"
            inDataSettings={true}
          >
            <MenuItem
              value={Compare.CUSTOM}
              primaryText="Custom"
              onClick={() => setCompare(Compare.CUSTOM)}
            />
          </CompareSelector>
          <MonthYearRange
            selected={
              compare === Compare.NONE || compare === Compare.RECURRING
                ? null
                : compareInterval
            }
            yearsOnly={precision === Precision.YEARLY}
            bounds={
              precision === Precision.MONTHLY
                ? lowestInterval(timeBounds, timespanInterval)
                : convertToYearlyPrecision(
                    lowestInterval(timeBounds, timespanInterval),
                    lowestInterval(timeBounds, timespanInterval),
                  )
            }
            onChange={setCustomCompareInterval}
          />
          <Divider />
        </Fragment>
      )}
    </Container>
  );
};

DataSettings.propTypes = {
  precision: IPrecision.isRequired,
  compare: ICompare.isRequired,
  metric: IMetric.isRequired,
  timespan: ITimespan.isRequired,
  compareInterval: string,
  timespanInterval: string,

  timeBounds: string.isRequired,
  availableCompare: arrayOf(string).isRequired,

  setMetric: func.isRequired,
  setTimespan: func.isRequired,
  setPrecision: func.isRequired,
  setCompare: func.isRequired,
  setCustomTimespanInterval: func.isRequired,
  setCustomCompareInterval: func.isRequired,
};

export default DataSettings;



// WEBPACK FOOTER //
// ./src/components/DataSettings.jsx